import React, { useState, useEffect, useContext } from 'react';

import { Bar } from 'react-chartjs-2';
import Paper from '@material-ui/core/Paper';
import { Tabs, Tab } from '@material-ui/core';

import getChartData from '../api/UsageChartData';

const options = {
	plugins: {
		legend: {
			display: false,
		},
	},
	scales: {
		yAxes: [
			{
				ticks: {
					beginAtZero: true,
				},
			},
		],
	},
};

const UsageChart = (props) => {
	const [loaded, setLoaded] = useState(false);
	const [value, setValue] = useState(0);
	const [chartData, setChartData] = useState({ datasets: [], labels: [] });

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	useEffect(() => {
		if (!loaded) {
			getChartData({ setChartData });
			setLoaded(true);
		}
	}, []);

	return (
		<div
			style={{
				width: '100%',
				background: 'white',
				borderRadius: 5,
				border: '1px solid #ddd',
				boxSizing: 'border-box',
				marginTop: 25,
			}}
		>
			<Paper
				square
				elevation={0}
				style={{
					borderBottom: '1px solid #ddd',
					borderTopLeftRadius: 5,
					borderTopRightRadius: 5,
				}}
			>
				<Tabs
					value={value}
					indicatorColor="primary"
					textColor="primary"
					onChange={handleChange}
					aria-label="disabled tabs example"
				>
					<Tab label="Electric Usage" />
					<Tab label="Water Usage" />
					{/* <Tab label="Pressurized Irrigation" /> */}
				</Tabs>
			</Paper>
			{value === 0 && (
				<Bar
					data={chartData.electric}
					options={options}
					style={{ padding: 25 }}
				/>
			)}
			{value === 1 && (
				<Bar
					data={chartData.water}
					options={options}
					style={{ padding: 25 }}
				/>
			)}
		</div>
	);
};

export default UsageChart;
